import axiosInstance from "../../../../config/axios-config";

async function fetchOngoingProjectList(url, jwtToken, setOngoingProjectList) {
  try {
    const response = await axiosInstance.get(url, {
      headers: {
        "Authorization": `Bearer ${jwtToken}`,
      },
    });
    
    const data = await response.data;
    
    setOngoingProjectList(data);
  } catch (err) {
    setOngoingProjectList({
      "EDAI": [],
      "SDP": [],
    });
  }
}

export { fetchOngoingProjectList };
